import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=99f4ad5e&scoped=true"
import script from "./Attachment.js?vue&type=script&lang=js&external"
export * from "./Attachment.js?vue&type=script&lang=js&external"
import style0 from "./Attachment.css?vue&type=style&index=0&id=99f4ad5e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f4ad5e",
  null
  
)

export default component.exports